module.exports = __webpack_public_path__ + "static/media/Judge.7b31ac42.jpg";